export
const name: string = "Lighting";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform mat3    u_normal_mat;
    uniform mat4    u_view_matrix;
    uniform mat4    u_light_mat;
    uniform mat4    u_manipulator_light;
`;

export
const varyings: string = `
    varying vec3    v_normal;
    varying vec3    v_normal_not_rotated;
    varying vec4    v_position;
`;

export
const implementation: string = `
    /**
     * Special case in geomtext
     */
    void setVaryingsForLighting0()
    {
        setVaryingsForLightingCommon0();

        v_normal_not_rotated = vec3(0.0);
        v_normal    = vec3(0.0);
        v_position  = vec4(0.0);
    }

    /**
     * Changed beacuse of instancing, without dependency on a_normal or a_position
     *
     * @param aNormal = a_normal
     * @param aEyeSpacePosition = ManipulatorTrafo * vec4(a_position * scale + a_offset, 1.0) ... modelMatrix * vertex
     * @param aClipSpacePosition = ProjectionMatrix * ViewMatrix * aEyeSpacePosition
     */
    void setVaryingsForLighting2(in vec3 aNormal, in vec4 aEyeSpacePosition, in vec4 aClipSpacePosition)
    {
        setVaryingsForLightingCommon2(aNormal, aEyeSpacePosition, aClipSpacePosition);

        v_normal_not_rotated = normalize(aNormal);
        v_normal = u_normal_mat * v_normal_not_rotated;
    #if defined(MANIPULATOR_ENABLED) && !defined(CHUNK_LOD)
        // change normals because of the manipulator transformation
        if (a_manipulation > 0.5) {
            v_normal_not_rotated = mat3(u_manipulator_light) * normalize(aNormal);
            v_normal = u_normal_mat * mat3(u_manipulator) * mat3(u_manipulator_light) * v_normal_not_rotated;
        }
    #endif

        // View * Model * Vertex
        v_position  = u_view_matrix * aEyeSpacePosition;
    }
`;
